module.exports = __webpack_public_path__ + "img/infinity-kingdom.7ac4c8c.png";